export enum PlanType {
    CHEFS_CHOICE = 'chefs_choice',
    CHEFS_CHOICE_PLUS = 'chefs_choice_plus',
    PREPARED_ONE_SERVING = 'prepared_one_serving',
    HIGH_PROTEIN = 'high_protein',
    GLUTEN_FREE = 'gluten_free',
    JUMPSTART = 'jumpstart_program',
    HIGH_FIBER = 'high_fiber',
    LESS_PREP = 'quick_easy',
    FOUR_SERVINGS = 'four_servings'
}

export const PlanTitles: Record<PlanType, string> = {
  [PlanType.CHEFS_CHOICE]: "Chef's Choice",
  [PlanType.CHEFS_CHOICE_PLUS]: "Chef's Choice",
  [PlanType.PREPARED_ONE_SERVING]: "Chef's Choice",
  [PlanType.HIGH_PROTEIN]: 'High Protein',
  [PlanType.GLUTEN_FREE]: 'Gluten-Free',
  [PlanType.JUMPSTART]: 'Jumpstart Program',
  [PlanType.HIGH_FIBER]: 'High Fiber',
  [PlanType.LESS_PREP]: 'Less Prep',
  [PlanType.FOUR_SERVINGS]: 'Family Plan',
};

export const PlanServing: Record<PlanType, number> = {
  [PlanType.CHEFS_CHOICE]: 2,
  [PlanType.CHEFS_CHOICE_PLUS]: 2,
  [PlanType.PREPARED_ONE_SERVING]: 1,
  [PlanType.HIGH_PROTEIN]: 2,
  [PlanType.GLUTEN_FREE]: 2,
  [PlanType.JUMPSTART]: 1,
  [PlanType.HIGH_FIBER]: 2,
  [PlanType.LESS_PREP]: 2,
  [PlanType.FOUR_SERVINGS]: 4,
};

export enum PlanGroup {
    MEAL_KIT = 'MEAL_KIT',
    PREPARED = 'PREPARED',
    DIVERSIFIED = 'DIVERSIFIED',
    JUMPSTART = 'JUMPSTART'
}

export const PLAN_TYPE_TO_GROUP_NAME = {
  0: 'MEAL_KIT',
  1: 'PREPARED',
  2: 'JUMPSTART',
  3: 'DIVERSIFIED',
};

export const resolvePlanGroup = (planName: string | null, diversified: boolean) : PlanGroup => {
  if (diversified) return PlanGroup.DIVERSIFIED;
  if (planName === 'prepared_one_serving') {
    return PlanGroup.PREPARED;
  }
  if (planName === 'jumpstart_program') {
    return PlanGroup.JUMPSTART;
  }
  return PlanGroup.MEAL_KIT;
};

export interface PlanPricing {
    [extra: number]: {
        price: number;
    };
}

export interface PlanGroupModel {
    title: string;
    group: PlanGroup;
    plans: PlanType[];
    backgroundColor: string;
    displayMealCountToggle: boolean;
    mealCountOptions: number[];
    baseMealCount?: number;
    servingCountOptions?: number[];
    displayGoalToggle: boolean;
    pricing?: Partial<Record<PlanType, PlanPricing>>;
}
export class DiversifiedPlanGroup {
    static MEAL_KIT: PlanGroupModel = {
      title: 'Meal Kit',
      group: PlanGroup.MEAL_KIT,
      plans: [
        PlanType.CHEFS_CHOICE,
        PlanType.CHEFS_CHOICE_PLUS,
        PlanType.HIGH_PROTEIN,
        PlanType.GLUTEN_FREE,
        PlanType.LESS_PREP,
      ],
      backgroundColor: '#E3FB94',
      displayMealCountToggle: true,
      mealCountOptions: [3, 4],
      baseMealCount: 3,
      servingCountOptions: [2, 4],
      displayGoalToggle: true,
      pricing: {
        [PlanType.CHEFS_CHOICE]: {
          0: { price: 85.5 },
          1: { price: 114 },
        },
        [PlanType.CHEFS_CHOICE_PLUS]: {
          0: { price: 108.0 },
        },
        [PlanType.FOUR_SERVINGS]: {
          0: { price: 114 },
          1: { price: 171 },
        },
        [PlanType.HIGH_PROTEIN]: {
          0: { price: 85.50 },
          1: { price: 114 },
        },
        [PlanType.GLUTEN_FREE]: {
          0: { price: 85.50 },
          1: { price: 114 },
        },
        [PlanType.LESS_PREP]: {
          0: { price: 85.50 },
          1: { price: 114 },
        },
      },
    };

    static PREPARED: PlanGroupModel = {
      title: 'Ready-to-Eat',
      group: PlanGroup.PREPARED,
      plans: [
        PlanType.PREPARED_ONE_SERVING,
        PlanType.JUMPSTART,
      ],
      backgroundColor: '#D2F0EB',
      displayMealCountToggle: true,
      baseMealCount: 6,
      mealCountOptions: [6, 8, 10],
      displayGoalToggle: false,
      pricing: {
        [PlanType.PREPARED_ONE_SERVING]: {
          0: { price: 90 },
          2: { price: 120 },
          4: { price: 150 },
        },
      },
    };

    static DIVERSIFIED: PlanGroupModel = {
      title: 'Mix & Match',
      group: PlanGroup.DIVERSIFIED,
      plans: [
        PlanType.CHEFS_CHOICE,
        PlanType.HIGH_PROTEIN,
        PlanType.GLUTEN_FREE,
        PlanType.HIGH_FIBER,
      ],
      backgroundColor: '#F7F1E9',
      displayMealCountToggle: false,
      displayGoalToggle: true,
      mealCountOptions: [0],
      pricing: {
        [PlanType.HIGH_FIBER]: {
          0: { price: 114 },
        },
        [PlanType.HIGH_PROTEIN]: {
          0: { price: 114 },
        },
        [PlanType.GLUTEN_FREE]: {
          0: { price: 114 },
        },
        [PlanType.CHEFS_CHOICE]: {
          0: { price: 114 },
        },
      },
    };

    static JUMPSTART: PlanGroupModel = {
      title: 'Jumpstart',
      group: PlanGroup.JUMPSTART,
      plans: [
        PlanType.PREPARED_ONE_SERVING,
        PlanType.JUMPSTART,
      ],
      backgroundColor: '#D2F0EB',
      displayMealCountToggle: false,
      displayGoalToggle: false,
      mealCountOptions: [0],
      pricing: {
        [PlanType.JUMPSTART]: {
          0: { price: 130 },
        },
      },
    };
}
